import React, { useCallback, useState } from 'react';
import { Text, Thumbnail, Link, Button, IndexTable, useBreakpoints, Icon } from '@shopify/polaris';
import { useDeleteProductVariant, useGetProductVariants } from 'queries/product_variant.query';
import __helpers from 'helpers/index';
import PopoverWithSearchableListbox from './productVariantGroupSearchBox';
import ProductVariantModalEdit from './product_variant_modal';
import { DiscountIcon, DeleteIcon } from '@shopify/polaris-icons';
export default function ProductVariants({
  current_product_id
}: {
  current_product_id: string;
}) {
  const {
    data: entities
  } = useGetProductVariants(current_product_id);
  const {
    mutate: mutateDeleteProductVariant
  } = useDeleteProductVariant();
  const [showModal, setShowModal] = useState<any>(null);
  const deleteProductVariant = useCallback((id: string) => {
    mutateDeleteProductVariant(id);
  }, []);
  const breakPoint = useBreakpoints();
  const MainData = useCallback(() => {
    if (!Array.isArray(entities) || __helpers.isEmpty(entities)) return <Text as="p" tone="subdued">
          Chưa có một phiên bản khác nào!
        </Text>;
    return <IndexTable headings={[{
      title: ''
    }, {
      title: 'Tên'
    }, {
      title: 'Giá'
    }, {
      title: 'SKU'
    }, {
      title: 'Barcode'
    }, {
      title: '-'
    }]} selectable={false} sortable={[]} itemCount={entities?.length ?? 0} condensed={breakPoint.smDown} hasZebraStriping>
        {entities.map((variantElement, index) => {
        return [<IndexTable.Row disabled={variantElement.variant_status === 0} id={`product_variant_` + index} key={`product_variant_key_` + index} position={index}>
              <IndexTable.Cell>
                <Thumbnail source={__helpers.getMediaLink(variantElement.variant_thumbnail_to_media ? variantElement.variant_thumbnail_to_media.media_thumbnail ? variantElement.variant_thumbnail_to_media.media_thumbnail['128x128'] : undefined : undefined)} alt="" size="small" />
              </IndexTable.Cell>
              <IndexTable.Cell>
                <div style={{
              width: '120px',
              overflow: 'auto',
              whiteSpace: 'normal',
              display: 'flex',
              alignContent: 'start'
            }}>
                  {!__helpers.isEmpty(variantElement.product_variant_commission || variantElement.product_variant_rebate) && <Button variant="monochromePlain" icon={DiscountIcon}></Button>}
                  <Link removeUnderline onClick={() => setShowModal(variantElement.variant_id)}>
                    {variantElement.variant_name}
                  </Link>
                </div>
              </IndexTable.Cell>
              <IndexTable.Cell>
                <Text as="h3" fontWeight="bold" tone="caution">
                  {__helpers.formatNumber(variantElement.variant_price)} đ
                </Text>
                <Text as="p" variant="bodyXs" tone="disabled">
                  <del>{__helpers.formatNumber(variantElement.variant_original_price)} đ</del>
                </Text>
              </IndexTable.Cell>
              <IndexTable.Cell>{variantElement.variant_sku ?? '-'}</IndexTable.Cell>
              <IndexTable.Cell>{variantElement.variant_barcode ?? '-'}</IndexTable.Cell>
              <IndexTable.Cell>
                <Button variant="plain" icon={DeleteIcon} onClick={() => deleteProductVariant(variantElement.variant_id)}></Button>
              </IndexTable.Cell>
            </IndexTable.Row>];
      })}
      </IndexTable>;
  }, [entities]);
  return <>
      <ProductVariantModalEdit variant_id={showModal} show={!!showModal} onClose={() => {
      setShowModal(null);
    }} />
      {current_product_id ? <>
          <PopoverWithSearchableListbox current_product_id={current_product_id} />
          <MainData />
        </> : <>
          <Text as="p" tone="subdued">
            Lưu bản nháp trước, sau đó sẽ thêm được các phiên bản của sản phẩm...
          </Text>
        </>}
    </>;
}